import Store from 'lightningjs-redux';
import { getLayoutNavigation } from '../../logic/layout/layout.selectors';
import { getCurrentPath } from '../../logic/routing/routing.selectors';

const mapControllers = instance => ({
  currentPath: {
    selector: getCurrentPath,
    shouldBeInvokedOnConnect: true,
    callback: value => {
      instance.path = value;
    },
  },
  layoutNavigation: {
    selector: getLayoutNavigation,
    shouldBeInvokedOnConnect: true,
    callback: value => {
      instance.navigation = value;
    },
  },
});

export default Store.control(mapControllers);
